import { Modal, Button } from 'react-bootstrap';
import React, { useEffect, useState } from 'react';
import { FaPlus } from 'react-icons/fa';
import * as api from '~/Services/Service';
import { toast } from 'react-toastify';
import { URLV1 } from '../Navbar/links';
import { FaWindowClose } from 'react-icons/fa';
import Loading from '../../Components/Loading';
import AuthStorage from '~/Utils/AuthStorage';
import { caracteristicas } from '~/constant';
import { gerarAmbienteUrl } from '~/Pages/Vendas/helpers';
import { isRotaPdfViaToken, abrirDocumentoTemporario } from '~/Utils/Helpers';

const MEIO_VISUALIZACAO_REACT = 1;

const ModalDocumentos = ({ mostrarModal, setMostrarModal, preVenda, casa }) => {
  const [temBoleto, setTemBoleto] = useState(false);
  const [preVendaDocumentos, setPreVendaDocumentos] = useState(null);

  useEffect(() => {
    verificarBoletoPreVenda();
    buscarDocumentos();
  }, []);

  const verificarBoletoPreVenda = async () => {
    try {
      const response = await api.verificarBoletoPreVenda(preVenda);
      if (response !== null && response !== undefined) {
        if (response === true) {
          setTemBoleto(true);
        } else {
          setTemBoleto(false);
        }
      }
    } catch (error) {
      toast.error(error.message);
    }
  };

  const buscarDocumentos = async () => {
    try {
      const response = await api.buscarDocumentosPreVenda(preVenda);
      if (response) {
        setPreVendaDocumentos(response);
      }
    } catch (error) {
      toast.error(error.message);
    }
  };

  const resolverUrlDocumento = async doc => {
    if (isRotaPdfViaToken(doc.relative_url)) {
      try {
        const resp = await api.gerarUrlDocumentoTemporario(doc.relative_url);
        return resp.url;
      } catch (err) {
        return null;
      }
    }
    if (doc.meio_visualizacao === MEIO_VISUALIZACAO_REACT) {
      return `/visualizar-pdf?url=${encodeURIComponent(doc.relative_url)}`;
    }
    return doc.url || null;
  };

  const AbrirTodosDocumentos = async item => {
    const docs = [
      ...item.documentos_para_assinatura,
      ...item.documentos_extras,
    ];

    const abas = docs.map(() => window.open('', '_blank'));
    const abaBoleto = temBoleto ? window.open('', '_blank') : null;

    if (abas.some(a => !a) || (temBoleto && !abaBoleto)) {
      abas.forEach(a => a && a.close());
      if (abaBoleto) abaBoleto.close();
      toast.error('Habilite pop-ups para abrir todos os documentos.');
      return;
    }

    await Promise.all(
      docs.map(async (doc, index) => {
        const url = await resolverUrlDocumento(doc);
        if (url) {
          abas[index].location.href = url;
        } else {
          abas[index].close();
        }
      })
    );

    if (abaBoleto) {
      abaBoleto.location.href = `/impressao/${preVenda}`;
    }
  };

  return (
    <div>
      {preVendaDocumentos && (
        <Modal
          show={mostrarModal}
          onHide={() => setMostrarModal(false)}
          backdrop="static"
        >
          <Modal.Header closeButton>
            <Modal.Title>Documentos disponíveis</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <section>
              <strong className="d-block">
                Documentos a serem enviados para assinatura
              </strong>
              {preVendaDocumentos.documentos_para_assinatura && (
                <ul className="list-group mt-2">
                  {preVendaDocumentos.documentos_para_assinatura.map(
                    (nomeLink, index) => {
                      const isContratoVenda =
                        nomeLink.nome === 'Contrato da Venda';
                      const isCasa = casa !== 0;
                      const podeVisualizarContratoConstrucao = AuthStorage.temCaracteristica(
                        caracteristicas.VisualizaContratoConstrucao
                      );

                      if (
                        isContratoVenda &&
                        isCasa &&
                        !podeVisualizarContratoConstrucao
                      ) {
                        return (
                          <li key={index} className="list-group-item">
                            <span className="text-muted">
                              Contrato da Venda (visualização não permitida)
                            </span>
                          </li>
                        );
                      }

                      if (
                        nomeLink.meio_visualizacao === MEIO_VISUALIZACAO_REACT
                      ) {
                        if (isRotaPdfViaToken(nomeLink.relative_url)) {
                          return (
                            <li key={index} className="list-group-item">
                              <a
                                href="#"
                                onClick={e => {
                                  e.preventDefault();
                                  abrirDocumentoTemporario(
                                    nomeLink.relative_url
                                  );
                                }}
                              >
                                {' '}
                                {nomeLink.nome}
                              </a>
                            </li>
                          );
                        }

                        return (
                          <li key={index} className="list-group-item">
                            <a
                              href={`/visualizar-pdf?url=${encodeURIComponent(
                                nomeLink.relative_url
                              )}`}
                              rel="noopener noreferrer"
                              target="_blank"
                            >
                              {' '}
                              {nomeLink.nome}
                            </a>
                          </li>
                        );
                      }

                      return (
                        <li key={index} className="list-group-item">
                          <a
                            href={
                              gerarAmbienteUrl(true) + nomeLink.relative_url
                            }
                            rel="noopener noreferrer"
                            target="_blank"
                          >
                            {' '}
                            {nomeLink.nome}
                          </a>
                        </li>
                      );
                    }
                  )}
                </ul>
              )}
              {temBoleto && (
                <div className="mt-2">
                  <strong className="d-block mt-2">Títulos</strong>
                  <ul className="list-group mt-2">
                    <li key={0} className="list-group-item">
                      <a href={`/impressao/${preVenda}`}> Imprimir Boletos </a>
                    </li>
                  </ul>
                </div>
              )}
              {preVendaDocumentos.documentos_extras &&
                preVendaDocumentos.documentos_extras.length > 0 && (
                  <div className="mt-2">
                    <strong className="d-block mt-2">Documentos extras</strong>
                    <ul className="list-group mt-2">
                      {preVendaDocumentos.documentos_extras.map(
                        (nomeLink, index) => {
                          if (isRotaPdfViaToken(nomeLink.relative_url)) {
                            return (
                              <li key={index} className="list-group-item">
                                <a
                                  href="#"
                                  onClick={e => {
                                    e.preventDefault();
                                    abrirDocumentoTemporario(
                                      nomeLink.relative_url
                                    );
                                  }}
                                >
                                  {' '}
                                  {nomeLink.nome}{' '}
                                </a>
                              </li>
                            );
                          }

                          return (
                            <li key={index} className="list-group-item">
                              <a
                                href={
                                  nomeLink.meio_visualizacao === MEIO_VISUALIZACAO_REACT
                                    ? `/visualizar-pdf?url=${encodeURIComponent(nomeLink.relative_url)}`
                                    : gerarAmbienteUrl(true) + nomeLink.relative_url
                                }
                                rel="noopener noreferrer"
                                target="_blank"
                              >
                                {' '}
                                {nomeLink.nome}{' '}
                              </a>
                            </li>
                          );
                        }
                      )}
                    </ul>
                  </div>
                )}
              {AuthStorage.temCaracteristica(
                caracteristicas.VisualizarContratoCompilado
              ) &&
                preVendaDocumentos.documentos_digitais &&
                preVendaDocumentos.documentos_digitais.length > 0 && (
                  <div className="mt-2">
                    <strong className="d-block mt-2">
                      Documentos Digitais
                    </strong>
                    <ul className="list-group mt-2">
                      {preVendaDocumentos.documentos_digitais.map(
                        (contrato, index) => (
                          <li key={index} className="list-group-item">
                            <a
                                href="#"
                                onClick={e => {
                                  e.preventDefault();
                                  abrirDocumentoTemporario(
                                    contrato.link_pdf.relative_url
                                  );
                                }}
                              >
                                {' '}
                                {contrato.link_pdf.nome}
                            </a>
                          </li>
                        )
                      )}
                    </ul>
                  </div>
                )}
              <Button
                variant="primary"
                type="button"
                className="mt-4"
                onClick={() => {
                  AbrirTodosDocumentos(preVendaDocumentos);
                }}
              >
                <FaPlus />
                <span className="ml-2 d-xs-none">Abrir todos</span>
              </Button>
            </section>
          </Modal.Body>
          <Modal.Footer>
            <>
              <Button
                variant={'light'}
                type="submit"
                className="d-inline-flex align-items-center"
                onClick={() => {
                  setMostrarModal(false);
                }}
              >
                <FaWindowClose />
                <span className="ml-2 d-xs-none">Fechar</span>
              </Button>
            </>
          </Modal.Footer>
        </Modal>
      )}
      {!preVendaDocumentos && (
        <div>
          <Loading></Loading>
        </div>
      )}
    </div>
  );
};

export default ModalDocumentos;
